import Extend from 'flarum/common/extenders';
import SouqPage from './components/SouqPage';
export default [new Extend.Routes().add('pinoytalks.souq', '/souq', SouqPage)];